module.exports = __webpack_public_path__ + "Assets/Images/onboarding/overview-steps-no-colors.png";